import React, { useState } from "react";
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import { Footer } from "./Footer";
import { HeroAlt } from "./HeroAlt";
import Navigation from "./Navigation";

export const ContactPage = () => {
  const [validated, setValidated] = useState(null);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  return (
    <div>
      <header>
        <Navigation />
        <HeroAlt
          title="Contact"
          pageDescription="This will give you the opportunity for customers to be able to contact you regarding your services, book appointments or enquire about prices and work."
        />
      </header>
      <main>
        <Container fluid as="section" className="contact-page">
          <Container>
            <Row>
              <Col>
                <Form
                  noValidate
                  validated={validated}
                  onSubmit={handleSubmit}
                  data-netlify="true"
                  name="contact"
                  method="POST"
                  className="contactForm"
                  netlify-honeypot="bot-field"
                >
                  <p className="d-none">
                    <label>
                      Don’t fill this out if you’re human:
                      <input name="bot-field" />
                    </label>
                  </p>
                  <input type="hidden" name="form-name" value="contact" />
                  <Row>
                    <Col>
                      <Form.Control
                        required
                        className="mb-3"
                        name="firstName"
                        id="firstName"
                        placeholder="First name"
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter your first name
                      </Form.Control.Feedback>
                    </Col>
                    <Col>
                      <Form.Control
                        required
                        className="mb-3"
                        name="lastName"
                        id="lastName"
                        placeholder="Last name"
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter your last name
                      </Form.Control.Feedback>
                    </Col>
                  </Row>
                  <Form.Group className="mb-3">
                    <Form.Control
                      required
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Email Address"
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter your email address
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Control
                      required
                      as="textarea"
                      name="message"
                      id="message"
                      rows={6}
                      placeholder="Message"
                    />
                  </Form.Group>
                  <Form.Control.Feedback type="invalid">
                    Your didn't provide a message...
                  </Form.Control.Feedback>
                  <Button type="submit" variant="site-contact-form">
                    Send
                  </Button>
                </Form>
              </Col>
            </Row>
          </Container>
        </Container>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};
